import { XMarkIcon } from '@heroicons/react/20/solid';

// `inset` defaults to what every caller had before it existed, so overriding it is opt-in.
export default function ModalX({ setOpen, inset = 'pr-4 pt-4' }) {
  return (
    <div className={`absolute right-0 top-0 ${inset}`}>
      <button
        type='button'
        autoFocus={false}
        className='rounded-md text-gray-400 hover:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2'
        onClick={() => setOpen(false)}>
        <span autoFocus={false} className='sr-only'>
          Close
        </span>
        <XMarkIcon autoFocus={false} className='h-6 w-6' aria-hidden='true' />
      </button>
    </div>
  );
}
